{
  "name": "leadlife-dashboard",
  "version": "4.1.3",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "generatePeerComparisonItems": "node ./scripts/generatePeerComparisonItems.js $npm_config_path"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.9",
    "@angular/cdk": "^21.2.7",
    "@angular/common": "^21.2.9",
    "@angular/compiler": "^21.2.9",
    "@angular/core": "^21.2.9",
    "@angular/forms": "^21.2.9",
    "@angular/material": "^21.2.7",
    "@angular/platform-browser": "^21.2.9",
    "@angular/platform-browser-dynamic": "^21.2.9",
    "@angular/router": "^21.2.9",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "angularx-qrcode": "^21.0.5",
    "apexcharts": "^5.3.4",
    "hammerjs": "^2.0.8",
    "ng-apexcharts": "^2.0.1",
    "ngx-markdown": "^21.2.0",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "uuid": "^14.0.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^21.2.7",
    "@angular/cli": "^21.2.7",
    "@angular/compiler-cli": "^21.2.9",
    "@types/hammerjs": "^2.0.46",
    "@types/jasmine": "~5.1.9",
    "@types/node": "^24.3.0",
    "@types/qrcode": "^1.5.5",
    "@types/uuid": "^10.0.0",
    "csv-parser": "^3.2.0",
    "jasmine-core": "~5.9.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.9.2"
  }
}